module.exports = __webpack_public_path__ + "img/2gis.89bccc28.svg";